export default {
    'ONBOARDING.OPTION.HUB.TEAM': 'Hub',
    'ONBOARDING.OPTION.HUB.TITLE': 'Add a hub',
    'ONBOARDING.OPTION.TEAMS.TITLE': 'Hubs',
    'ONBOARDING.OPTION.TEAMS.ASIDE': 'You can still edit your hubs here or go to the next step.',
    'ONBOARDING.OPTION.TEAMS.FORM.TITLE': 'Hub name',
};
